import React, { useState } from 'react';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material'; // 1. ADD THIS IMPORT
import '../../styles/components/_playerSelection.css';

const PlayerSelection = ({ players, selectedPlayers, onTogglePlayer, colors, isSelectionLocked }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="player-selection-container">
      <div className="player-selection-header" onClick={() => setIsExpanded(!isExpanded)}>
        <h2 className="section-title">Select Players</h2>
        
        {/* 2. UPDATE THIS BUTTON */}
        <button 
          onClick={() => setIsExpanded(!isExpanded)} 
          className={`toggle-button ${isExpanded ? '' : 'collapsed'}`}
          aria-label="Toggle player list"
        >
          <ExpandMoreIcon />
        </button>
      </div>

      <div 
        className={`player-checkbox-grid ${isExpanded ? 'expanded' : 'collapsed'}`}
      >
        {players.map((player) => (
          <label
            key={player}
            className="player-checkbox-label"
          >
            <input
              type="checkbox"
              checked={selectedPlayers.includes(player)}
              onChange={() => onTogglePlayer(player)}
              className="player-checkbox"
              disabled={isSelectionLocked && !selectedPlayers.includes(player)}
            />
            <span
              className="player-name"
              style={{
                color: selectedPlayers.includes(player) ? colors[player] : 'var(--text-color)'
              }}
            >
              {player}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default PlayerSelection;